import reportOuterWrapper from './reportOuterWrapper'
export default reportOuterWrapper
